// Copyright (c) 2020 Deere & Company

import actions from '../../actions-list';

export const updateSelectedDealer = (dealer, isSelected) =>
    dispatch => {

        dispatch({
            dealer,
            isSelected,
            type: actions.UPDATE_TCSM_SELECTED_DEALER_ACCOUNTS
        });

    };




// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/action-creators/dealers-selected.js